import { render, staticRenderFns } from "./HowtoItem.vue?vue&type=template&id=34b460b8&"
import script from "./HowtoItem.vue?vue&type=script&lang=js&"
export * from "./HowtoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports